import * as React from "react";
const SvgZap = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.205 1.338a1.035 1.035 0 0 1 1.822.79l-.854 6.837h6.12c.25 0 .512 0 .723.018.166.015.47.053.759.236l.123.087.13.118c.286.29.445.687.439 1.1s-.208.726-.316.883c-.121.175-.288.374-.45.568l-8.906 10.687a1.035 1.035 0 0 1-1.822-.79l.854-6.837H4.708c-.252 0-.512 0-.723-.018-.19-.018-.56-.063-.882-.323a1.54 1.54 0 0 1-.57-1.217l.011-.15c.044-.34.21-.597.305-.734.12-.175.288-.374.449-.568zM5.21 12.965H12a1.035 1.035 0 0 1 1.027 1.163l-.562 4.497 6.325-7.59H12a1.037 1.037 0 0 1-1.027-1.163l.561-4.498z"
}));
export default SvgZap;
//# sourceMappingURL=Zap.js.map